<div class="alert alert-success" role="alert">
    <strong>Success!</strong> You are now signed out.
</div>